var wFlag = window.innerWidth>750

function showUp(dom){
    gsap.from(dom, {
        y: '2rem', opacity: 0, ease: 'none', duration: 0.5,
        scrollTrigger: {
            trigger: dom,
            start: 'top bottom-=20%',
            end: '+=0',
            toggleActions: 'play none none reverse',
        }
    })
}

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

onViewLoad('.lazy_video')
if(wFlag){
    onViewLoad('.lazy_video_p')
}else{
    onViewLoad('.lazy_video_m')
}

$(()=>{
    setInterval(() => {
        $('.box1_title').css({ transform: 'translateY(0)', opacity: 1 })
    }, 300);

    ScrollTrigger.create({
        trigger: '.box1_text',
        start: 'top center-=10%',
        end: '+=80%',
        scrub: 1,
        toggleActions: 'play none none reverse',
        onUpdate(self) {
            let index = Math.floor(self.progress * 100);
            for(let i=0;i<3;i++){
                if(index>i*30){
                    $('.box1_text div p').eq(i).addClass('box1Active').siblings().removeClass('box1Active')
                }
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box2_item',
        start:'top bottom-=10%',
        end:'+=80%',
        scrub:1,
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box2_item div',{opacity:0,y:'2rem',stagger:0.2})
    })

    showUp('.box3_title')
    if(wFlag){
        ScrollTrigger.create({
            trigger: '.box3',
            start: 'top center',
            end: '+=20%',
            scrub:1,
            animation: gsap.timeline().to('.box3_item div', { x:0,xPercent:0 })
        })
    }

    ScrollTrigger.create({
        trigger: '.box_text1',
        start: 'top bottom-=30%',
        end: '+=80%',
        scrub:1,
        animation: gsap.timeline()
            .fromTo('.box_text1 div p', { backgroundSize:'12% 100%' },{ backgroundSize:'88% 100%' })
            .fromTo('.box_text1 div img:nth-child(2)', { x:'12%' },{ x:'88%' },'<')
    })

    //box4
    showUp('.box4_title')
    ScrollTrigger.create({
        trigger: '.box4',
        start: 'top center-=10%',
        end: '+=0%',
        toggleActions:'play none none reverse',
        animation: gsap.timeline().from('.box4 img',{ opacity:0 })
    })
    showUp('.box4_info')
    ScrollTrigger.create({
        trigger: '.box4_item',
        start: wFlag?'top+=20% top+=4%':'top+=20% top+=8%',
        end: '+=0%',
        toggleActions: 'play none none reverse',
        animation: gsap.timeline()
            .to('.box4_flag,.Mbox4_video', { opacity:0 })
            .from('.box4_info2', { opacity:0,y:'10%' },'-=50%')
    })
    ScrollTrigger.create({
        trigger: '.box4_item',
        start: wFlag?'top top+=4%':'top top+=8%',
        end: '+=50%',
        pin:true
    })

    ScrollTrigger.create({
        trigger: '.box_text2',
        start: 'top bottom-=30%',
        end: '+=80%',
        scrub:1,
        animation: gsap.timeline()
            .fromTo('.box_text2 div p', { backgroundSize:'21% 100%' },{ backgroundSize:'79% 100%' })
            .fromTo('.box_text2 div img:nth-child(2)', { x:'21%' },{ x:'79%' },'<')
    })

    //box5
    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5', 
        start:'top top+=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        onEnter: () => {
            $('.box5_num p').addClass('box5Active')
            $('.box5_img').css({transform:'translateY(0)',opacity:1})
        },
        // onLeaveBack: () => {
        // }
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5', 
            start:'top+=30% top+=6%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation: gsap.timeline()
                .to('.box5_1',{ opacity:0 })
                .from('.box5_2',{ x:'100%' },'-=50%')
        })
        ScrollTrigger.create({
            trigger:'.box5', 
            start:'top top+=6%',
            end:'+=80%',
            pin:true,
        })
        
        //box6
        showUp('.box6_title')
        ScrollTrigger.create({
            trigger:'.box6', 
            start:'top+=20% top+=4%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation: gsap.timeline()
                .from('.box6_btn',{ y:'2.4%' })
                .from('.box6_ui',{ opacity:0 },'<')
                .to('.box6_flag',{ opacity:0 })
                .from('.box6_item',{ opacity:0,y:'30%' },'-=50%')
        })
        ScrollTrigger.create({
            trigger:'.box6', 
            start:'top top+=4%',
            end:'+=60%',
            pin:true,
        })
    }else{
        showUp('.box5_title2')
        
        //box6
        showUp('.box6_title')
        ScrollTrigger.create({
            trigger:'.box6', 
            start:'top+=10% top+=6%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation: gsap.timeline()
                .from('.box6_btn',{ y:'2.4%' })
                .from('.box6_ui',{ opacity:0 },'<')
        })
        ScrollTrigger.create({
            trigger:'.box6', 
            start:'top+=40% top+=6%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation: gsap.timeline()
                .to('.box6_flag,.box6_img',{ opacity:0 })
                .from('.box6_item',{ opacity:0,y:'30%' },'-=50%')
        })
        ScrollTrigger.create({
            trigger:'.box6', 
            start:'top top+=6%',
            end:'+=60%',
            pin:true,
        })
    }

    ScrollTrigger.create({
        trigger: '.box_text3',
        start: 'top bottom-=30%',
        end: '+=80%',
        scrub:1,
        animation: gsap.timeline()
            .fromTo('.box_text3 div p', { backgroundSize:'7% 100%' },{ backgroundSize:'93% 100%' })
            .fromTo('.box_text3 div img:nth-child(2)', { x:'7%' },{ x:'93%' },'<')
    })

    //box7
    ScrollTrigger.create({
        trigger: '.box7',
        start: 'top+=20% top+=4%',
        end: '+=0%',
        toggleActions: 'play none none reverse',
        onUpdate(self) {
            let index = Math.floor(self.progress * 10);
            $('.box7_img img:last-child').toggleClass('opacity1',index>2)
            $('.box7_title div').toggleClass('box7Active',index>2)
        }
    })
    ScrollTrigger.create({
        trigger: '.box7',
        start: 'top top+=4%',
        end: '+=50%',
        pin:true
    })

    //box8
    showUp('.box8_title')
    ScrollTrigger.create({
        trigger: '.box8',
        start: 'top+=20% top+=4%',
        end: '+=0%',
        toggleActions: 'play none none reverse',
        onUpdate(self) {
            let index = Math.floor(self.progress * 10);
            $('.box8_text,.box8_img').toggleClass('box8Active',index>2)
        }
    })
    ScrollTrigger.create({
        trigger: '.box8',
        start: 'top top+=4%',
        end: '+=50%',
        pin:true
    })

    ScrollTrigger.create({
        trigger: '.box_text4',
        start: 'top bottom-=30%',
        end: '+=80%',
        scrub:1,
        animation: gsap.timeline()
            .fromTo('.box_text4 div p', { backgroundSize:'21% 100%' },{ backgroundSize:'79% 100%' })
            .fromTo('.box_text4 div img:nth-child(2)', { x:'21%' },{ x:'79%' },'<')
    })

    //box9
    showUp('.box9_title')
    ScrollTrigger.create({
        trigger: '.box9',
        start: 'top+=20% top+=4%',
        end: '+=0%',
        toggleActions: 'play none none reverse',
        onUpdate(self) {
            let index = Math.floor(self.progress * 10);
            $('.box9').toggleClass('box9Active',index>2)
        }
    })
    ScrollTrigger.create({
        trigger: '.box9',
        start: 'top top+=4%',
        end: '+=50%',
        pin:true
    })

    showUp('.box10_title')
    new Swiper('.box10Swiper', {
        autoplay: true,
        slidesPerView: 3,
        centeredSlides: true,
        loop:true
    })

    showUp('.box11_title')
    showUp('.box12_item')
    showUp('.box17_title')
    showUp('.box18_title')

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })
    
    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/oxva-vprime-2'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })
     
})